// This file is part of MinIO Design System
// Copyright (c) 2023 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import * as React from "react";
import { SVGProps } from "react";

const FilePdfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`min-icon`}
    fill={"currentcolor"}
    viewBox="0 0 256 256"
    {...props}
  >
    <g transform="translate(2588 -5250.899)">
      <path
        d="M188.5,255.974H14.5A14.5,14.5,0,0,1,0,241.475V14.5A14.5,14.5,0,0,1,14.5,0H128.834l.192.265L203,74.29V241.475a14.5,14.5,0,0,1-14.5,14.5Z"
        transform="translate(-2562 5250.924)"
        fill="#cf4646"
      />
      <path
        d="M83.177,74.2H147.99L73.787,0V64.8a10.156,10.156,0,0,0,9.39,9.4"
        transform="translate(-2507.328 5250.899)"
        fill="#e05555"
      />
      <path
        d="M7.585,119.23a6.1,6.1,0,0,1-1.8-1.158,15.827,15.827,0,0,1-3.339-3.187,11.919,11.919,0,0,1-1.957-3.742,11.057,11.057,0,0,1-.456-4.067,12.974,12.974,0,0,1,1.045-4.167l.01-.024.012-.023c1.5-3,4.792-6.243,9.78-9.635a112.834,112.834,0,0,1,17.269-9.3,3.542,3.542,0,0,0,.574-1.135,15.645,15.645,0,0,1,.636-1.483c3.565-7.924,6.651-15.468,9.173-22.423A176.013,176.013,0,0,0,44.846,37.9c-5.461-11.873-8.125-20.167-8.138-25.349-.335-3.764.354-6.776,2.047-8.954A9.283,9.283,0,0,1,43.267.512L43.3.5a12.331,12.331,0,0,1,3.38-.5,9.365,9.365,0,0,1,5.183,1.511,11.624,11.624,0,0,1,3.6,3.85l.018.029.015.03c1.527,3.053,2.152,7.425,1.859,13a95.235,95.235,0,0,1-3.2,18.544A177.1,177.1,0,0,0,75.133,68.812a91.158,91.158,0,0,1,16.869-2c3.688,0,6.527.479,8.439,1.425a7.615,7.615,0,0,1,4.969,9.167l-.011.054-.018.052c-1.5,4.513-3.621,7.9-6.291,10.056a11.066,11.066,0,0,1-7.019,2.613A9.4,9.4,0,0,1,90.259,90a22.889,22.889,0,0,1-8.689-3.471,55.3,55.3,0,0,1-9.284-7.58c-5.535,1.386-11.943,3.032-18.528,5.073a150.258,150.258,0,0,0-19.236,7.269c-2.51,4.7-5.451,10.073-8.36,14.585a46.038,46.038,0,0,1-8.045,9.935,14.61,14.61,0,0,1-4.532,3.139,9.088,9.088,0,0,1-3.511.815A6.4,6.4,0,0,1,7.585,119.23Zm4.776-15.051a14.419,14.419,0,0,0-2.278,2.674,3.249,3.249,0,0,0-.611,1.613c0,.091.063.279.364.654.236.3.577.654,1,1.081a42.316,42.316,0,0,0,3.58-3.9,83.648,83.648,0,0,0,5.633-7.851A47.916,47.916,0,0,0,12.361,104.179ZM85.276,76.2c-.771.076-1.6.157-2.474.24,3.676,3.115,6.746,3.621,8.349,3.621a2.818,2.818,0,0,0,2.2-1.256,13.6,13.6,0,0,0,1.78-3.158,13.43,13.43,0,0,0-1.493-.071C91.642,75.572,88.833,75.848,85.276,76.2ZM40,78.568c3.642-1.44,7.738-2.862,12.21-4.238,3.9-1.2,8.189-2.4,12.774-3.562A149.323,149.323,0,0,1,50.54,49.735,246.806,246.806,0,0,1,40,78.568Zm5.475-65.28a46.914,46.914,0,0,0,2.208,9.035,35.352,35.352,0,0,0,.37-6.873,9.451,9.451,0,0,0-1.915-5.771h-.58A9.161,9.161,0,0,0,45.476,13.288Z"
        transform="translate(-2509.726 5346.72)"
        fill="#fff"
      />
    </g>
  </svg>
);

export default FilePdfIcon;
